import React from "react";
import GovGrDrawerMenu from "../../../../components/GovGrDrawerMenu";
import CustomAlert from "../../../components/CustomAlert";
import { Typography } from "@material-ui/core";
import useLocale from "../../../../hooks/useLocale";
import styled from "styled-components";
import { useState } from "react";
import red from "@material-ui/core/colors/red";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ls from "local-storage";
import { Redirect, useHistory } from "react-router-dom";
import { updateGdprCompliance } from "../../../../services/gdprExternalUser";
import { useMutation } from "react-query";

const useStyles = makeStyles((theme) => ({
  form: {
    textAlign: "center",
  },
  submitButton: {
    backgroundColor: "#FFF",
    color: red[800],
    fontSize: "1rem",
    padding: "8px 10px",
    transition: "0.5s ease-in-out",
    "&:hover": {
      color: "#FFF",
      fontWeight: "bold",
      backgroundColor: red[800],
    },
  },
}));
const GdprPage = () => {
  const { t } = useLocale();
  const classes = useStyles();
  const [error, setError] = useState("");
  const afm = ls("afm");
  const { push } = useHistory();
  const [gdprDialogPop] = useState(parseInt(ls("gdpr_accept")) === 0);

  const { mutate } = useMutation(updateGdprCompliance, {
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const handleClose = () => {
    ls.set("gdpr_accept", 1);
    mutate({
      afm,
      gdpr_accept: 1,
    });

    push("/amkaverification");
  };

  return (
    <>
      {!gdprDialogPop ? (
        <Redirect to="/" />
      ) : (
        <>
          <CustomAlert
            open={!!error}
            close={() => {
              setError("");
            }}
            message={t("A network error occured, please try again later")}
          />
          <WrapperMessage>
            <Typography variant="h2">
              <u>{t("Chapter 5")}</u>
            </Typography>
            <br></br>
            <Typography variant="h4">
              <u>{t("Information about the Processing of Personal Data")}</u>
            </Typography>
            <br></br>

            <WrapperMainText>
              <Typography variant="body1">
                {t("GdprText.0")}
                <Links classes={classes.links} href="mailto:dner@hcg.gr">
                  {t("GdprText.1")}
                </Links>
                {t("GdprText.2")}
                <br></br>
                <br></br>
                {t("GdprOfficer.0")}
                <Links href="https://www.ynanp.gr/el/contact/epikoinwnia-dpo">
                  {t("GdprOfficer.1")}
                </Links>
                <br></br>
                <br></br>
                <br></br>
                {t("Gdprlastparagraph.0")}
                <Links href="https://www.hcg.gr">
                  {t("Gdprlastparagraph.1")}
                </Links>{" "}
                {t("Gdprlastparagraph.2")}
                <Links href="https://www.hnanp.gr">
                  {t("Gdprlastparagraph.3")}
                </Links>
                {t("Gdprlastparagraph.4")}
              </Typography>
            </WrapperMainText>
          </WrapperMessage>
          <ButtonWrapper>
            <Button onClick={handleClose} color="primary">
              <Typography variant="button" className={classes.submitButton}>
                {t("Submit")}
              </Typography>
            </Button>
          </ButtonWrapper>
        </>
      )}
    </>
  );
};

const Links = styled.a`
  &:visited {
    color: blue;
  }
`;

const WrapperMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const WrapperMainText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 3rem;
`;
export default GdprPage;
